var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Pane, AccordionSet, Accordion, PaneFooter, ErrorModal, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { RecekPaneSet } from "../RecekPaneSet";
import { ExpandCollapseToggle } from "../ExpandCollapseToggle";
import { FormFooterStart } from "../FormFooterStart";
import { FormFooterEnd } from "../FormFooterEnd";
import { usePublisherForm } from "../../hooks/usePublisherForm";
import { useScrollToError } from "../../hooks/useScrollToError";
import { PublisherGeneralSection } from "./PublisherGeneralSection";
import { PublisherAddressSection } from "./PublisherAddressSection";
import { PublisherContactsSection } from "./PublisherContactsSection";
import { extractServerErrorMessage } from "../../utils/errorHandler";
var PublisherForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var _b = useState({
        general: true,
        address: true,
        contacts: true,
    }), accordionStatus = _b[0], setAccordionStatus = _b[1];
    var _c = useState(true), expandAll = _c[0], setExpandAll = _c[1];
    var _d = useState(false), errorModalOpen = _d[0], setErrorModalOpen = _d[1];
    var _e = useState(""), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = usePublisherForm(initialValues), _g = _f.publisherForm, handleSubmit = _g.handleSubmit, control = _g.control, setValue = _g.setValue, trigger = _g.trigger, errors = _g.formState.errors, regionsData = _f.regionsData, legalFormValue = _f.legalFormValue, showMailingAddress = _f.showMailingAddress, setShowMailingAddress = _f.setShowMailingAddress, prepareSubmitData = _f.prepareSubmitData;
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            general: !expandAll,
            address: !expandAll,
            contacts: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    useScrollToError(errors);
    var handleFormSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var publisherData, error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 4]);
                    publisherData = prepareSubmitData(data);
                    return [4 /*yield*/, onSubmit(publisherData)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    _a = setErrorMessage;
                    return [4 /*yield*/, extractServerErrorMessage(error_1, formatMessage, formatMessage({
                            id: "ui-br-legaldeposits.publishers.edit.error.save",
                        }))];
                case 3:
                    _a.apply(void 0, [_b.sent()]);
                    setErrorModalOpen(true);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(FormFooterStart, { handleSubmit: handleSubmit, onSubmit: handleFormSubmit, buttonMessageId: "ui-br-legaldeposits.button.save" }), renderEnd: React.createElement(FormFooterEnd, { onCancel: onCancel, buttonMessageId: "ui-br-legaldeposits.button.cancel" }) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-legaldeposits.error.modal.title",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
            React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
            React.createElement("form", { onSubmit: function (e) { return e.preventDefault(); } },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.accordion.general",
                        }), open: accordionStatus.general, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { general: !accordionStatus.general }));
                        } },
                        React.createElement(PublisherGeneralSection, { control: control, errors: errors, setValue: setValue, trigger: trigger, legalFormValue: legalFormValue })),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.accordion.address",
                        }), open: accordionStatus.address, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { address: !accordionStatus.address }));
                        } },
                        React.createElement(PublisherAddressSection, { control: control, errors: errors, setValue: setValue, regionsData: regionsData, showMailingAddress: showMailingAddress, setShowMailingAddress: setShowMailingAddress })),
                    React.createElement(Accordion, { label: formatMessage({
                            id: "ui-br-legaldeposits.publishers.accordion.publisherContacts",
                        }), open: accordionStatus.contacts, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { contacts: !accordionStatus.contacts }));
                        } },
                        React.createElement(PublisherContactsSection, { control: control, errors: errors })))))));
};
export { PublisherForm };
